import React, { Component, Fragment } from 'react';
import { Input, Pagination, Dropdown, Menu, Select, Collapse, Table, Upload, message, Modal, Spin, Tabs, DatePicker,Button, InputNumber } from 'antd';
import { Api } from '../../../services';

import { CaretDownOutlined,CaretUpOutlined, LeftOutlined, UploadOutlined } from '@ant-design/icons';


const { Panel } = Collapse;
const { Option } = Select;

class WareHouseForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            visible: false,
            title: "Warehouse",
            data: [],
            step: 0,
            category: [],
            filter: [],
            wh_index_selected:0,
            wh_zone_index_selected:0,
            wh_page: 1,
            sorter:"wh_zone_loc_code",
            sortasc:1,
            modal:{
                visible:false,          
            }
            
        };
    }
    formname(formtype){
        switch(formtype){
            case 1.1:
                return 'Receive';
            case 1.2:
                return 'Withdraw';
            case 1.3:
                return 'Transfer';
            case 1.4:
                return 'Return';
            case 1.5:
                return 'Adjust';
            case 1.6:
                return 'AMO';
        }
    }
    AddNewMat = () =>{
        this.setState({
            modal:{
                visible:true
            }
        });
    }
    ModalClosed = () =>{
        this.setState({
            modal:{
                visible:false
            }
        });
    }

    render(){
        const { modal } = this.state;

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="font-mont-sb fs-18 c-blue mb-0"> 
                        <span className="fs-22">+ </span><span>{this.formname(this.props.type)}</span>
                    </div>
                    
                    <div className="card col-12">
                        <div className="card-body">
                            {this.props.type == 1.1 ? <div className="row d-flex justify-content-center">
                                <div className="col-6">
                                    <div className="row">
                                        <div className="font-mont-sb fs-14 c-blue mb-0">
                                            Select warehouse to Add
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-12">Order No</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12"><Input style={{width:'100%'}} /></div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-12">Requisition No</div>
                                            </div>
                                            <div className="row">
                                                
                                                <div className="col-12"><Input style={{width:'100%'}} /></div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-12">Document No.</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <Input style={{width:'100%'}} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-12">Document Type</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <Select
                                                        style={{ width: '100%' }}
                                                        placeholder="Document Type"
                                                    >
                                                        <Option value="wh_zone_loc_code">WH_CODE</Option>
                                                        <Option value="wh_zone_loc_name">WH_Name</Option>
                                                        <Option value="count_material">Material</Option>
                                                    </Select>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-12">Warehouse Zone</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <Select
                                                        style={{ width: '100%' }}
                                                        placeholder="Warehouse Zone"
                                                    >
                                                        <Option value="wh_zone_loc_code">WH_CODE</Option>
                                                        <Option value="wh_zone_loc_name">WH_Name</Option>
                                                        <Option value="count_material">Material</Option>
                                                    </Select>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-12">Warehouse Code</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <Input style={{width:'100%'}} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-12">Sub Warehouse</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <Select
                                                        style={{ width: '100%' }}
                                                        placeholder="Sub Warehouse"
                                                    >
                                                    </Select>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-12">Date Input</div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <DatePicker
                                                        style={{width:'100%'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row" style={{marginTop:'20px'}}>
                                        <div className="col-12 d-flex justify-content-center" style={{marginBottom:'20px'}}>
                                            <Button size="large" style={{color:'#000F9F',borderColor:'#000F9F'}} type="link" onClick={this.AddNewMat}> + Add Material </Button>
                                        </div>
                                        {/* 
                                        <div className="col-12 d-flex justify-content-center">
                                            Or
                                        </div>
                                        <div className="col-12 d-flex justify-content-center font-mont-sb fs-14 c-blue mb-0">
                                            Upload File
                                        </div>
                                        <div className="col-12 d-flex justify-content-center font-mont-sb fs-14 c-blue mb-0">
                                            <Upload {...WareHouseForm}>
                                                <Button>
                                                    <UploadOutlined /> Upload
                                                </Button>
                                            </Upload>
                                        </div>*/
                                        }
                                        
                                    </div>
                                </div>
                            </div> : null}
                            <div className="row">
                                <div className="col-12">
                                    <div className="row" style={{borderTop:'2px solid #E8CD00',borderBottom:'2px solid #E8CD00',margin:'10px',fontSize:13}}>
                                        <div className="col-4">
                                            <div className="row">
                                                <div className="col-4 text-center">Material Code</div>
                                                <div className="col-4">Material Type</div>
                                                <div className="col-4">Material Name</div>
                                            </div>
                                        </div>
                                        <div className="col-3">
                                            <div className="row">
                                                <div className="col-12 text-center">Description</div>
                                            </div>
                                        </div>
                                        <div className="col-5">
                                            
                                            <div className="row">
                                                <div className="col-2 text-center">Unit</div>
                                                <div className="col-2 text-center">Unit Price</div>                                        
                                                <div className="col-3 text-center">Lot No.</div>
                                                <div className="col-2 text-center">Qty</div>
                                                <div className="col-3 text-center">
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Modal
                                title={'Receive'}
                                centered={true}
                                visible={modal.visible}
                                forceRender={true}
                                keyboard={true}
                                closable={true}
                                onOk={this.ModalClosed}
                                onCancel={this.ModalClosed}
                                cancelText={"Cancel"}
                                okText={"Add material"}
                                footer={[
                                    <Button key="Cancel" onClick={this.ModalClosed}>
                                      Return
                                    </Button>,
                                    <Button key="Add" className="btn-warning" style={{background:"#E8CD00"}} type="primary" onClick={this.ModalClosed}>
                                      Submit
                                    </Button>,
                                  ]}
                                cancelButtonProps={{className:""}}
                                //okButtonProps={{type:"primary",className:"btn-warning",style:{background:"#E8CD00"}}}
                            >
                                <div className="row m-3">
                                    <div className="col-6">
                                        <div className="row">
                                            <div className="col-12">Material Type</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    placeholder="Document Type"
                                                >
                                                    <Option value="wh_zone_loc_code">WH_CODE</Option>
                                                    <Option value="wh_zone_loc_name">WH_Name</Option>
                                                    <Option value="count_material">Material</Option>
                                                </Select>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="row">
                                            <div className="col-12">Material Code</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <Input style={{width:'100%'}} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            <div className="row m-3">
                                <div className="col-6">
                                        <div className="row">
                                            <div className="col-12">Material Name</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <Input style={{width:'100%',cursor:'default'}} disabled={true}/>
                                            </div>
                                        </div>
                                </div>
                                <div className="col-6">
                                        <div className="row">
                                            <div className="col-12">Description</div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12">
                                                <Input style={{width:'100%',cursor:'default'}} disabled={true} />
                                            </div>
                                        </div>
                                </div>
                            </div>

                            <div className="row m-1">
                                <div className="col-3">
                                        <div className="row">
                                            <div className="col-12">Unit <span style={{color: 'red'}}>*</span></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <Input style={{width:'100%',cursor:'default'}} />
                                            </div>
                                        </div>
                                </div>
                                <div className="col-3">
                                        <div className="row">
                                        <div className="col-12">Unit Price <span style={{color: 'red'}}>*</span></div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-12">
                                                <Input style={{width:'100%',cursor:'default'}}  />
                                            </div>
                                        </div>
                                </div>

                                <div className="col-3">
                                        <div className="row">
                                            <div className="col-12">Qty</div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-12">
                                                <InputNumber style={{width:'100%',cursor:'default'}} min={1} max={10} defaultValue={3}  />
                                            </div>
                                        </div>
                                </div>
                                <div className="col-3">
                                        <div className="row">
                                            <div className="col-12">Minimum Qty</div>
                                        </div>
                                        
                                        <div className="row">
                                            <div className="col-12">
                                                <span style={{color: '#0500a3'}}>XXXX</span>
                                            </div>
                                        </div>
                                </div>
                            </div>
                                

                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



export default WareHouseForm;